import React, { useEffect, useState } from "react";
import { Plus, Search } from "lucide-react";
import { toast } from "sonner";
import api, { taka } from "@/lib/api";
import { Modal, Field, inputCls, Th, Td, Empty } from "@/pages/admin/AdminUI";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [form, setForm] = useState({ name: "", mobile: "", address: "", type: "retail" });

  const load = () => api.get("/admin/customers", { params: { search: q || undefined } }).then((r) => setCustomers(r.data));
  useEffect(() => { load(); }, []); // eslint-disable-line
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    if (!form.name) return toast.error("নাম দিন");
    await api.post("/admin/customers", form); toast.success("যোগ হয়েছে"); setOpen(false); setForm({ name: "", mobile: "", address: "", type: "retail" }); load();
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h1 className="text-2xl font-bold text-[#1E3A2B]">কাস্টমার</h1>
        <button onClick={() => setOpen(true)} className="bg-[#1E3A2B] text-white h-11 px-4 rounded-xl flex items-center gap-2 font-medium" data-testid="add-customer-btn"><Plus size={18} /> নতুন কাস্টমার</button>
      </div>
      <div className="relative max-w-sm">
        <input value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} placeholder="নাম / মোবাইল" className={`${inputCls} pl-9`} data-testid="customer-search" />
        <Search size={16} className="absolute left-3 top-3.5 text-stone-400" />
      </div>
      <div className="bg-white rounded-2xl border border-stone-200 overflow-x-auto">
        <table className="w-full min-w-[640px]">
          <thead className="bg-stone-50 border-b border-stone-200"><tr><Th>নাম</Th><Th>মোবাইল</Th><Th>ধরন</Th><Th>মোট অর্ডার</Th><Th>মোট কেনা</Th><Th>বাকি</Th></tr></thead>
          <tbody className="divide-y divide-stone-100">
            {customers.map((c) => (
              <tr key={c.id} data-testid={`customer-row-${c.id}`}>
                <Td className="font-medium">{c.name}</Td><Td>{c.mobile}</Td>
                <Td><span className={`text-xs px-2 py-0.5 rounded-full ${c.type === "wholesale" ? "bg-purple-100 text-purple-700" : "bg-blue-100 text-blue-700"}`}>{c.type === "wholesale" ? "পাইকারি" : "খুচরা"}</span></Td>
                <Td>{c.total_orders}</Td><Td>{taka(c.total_purchase)}</Td>
                <Td className={c.due > 0 ? "text-red-600 font-semibold" : "text-emerald-700"}>{taka(c.due)}</Td>
              </tr>
            ))}
          </tbody>
        </table>
        {customers.length === 0 && <Empty />}
      </div>

      <Modal open={open} onClose={() => setOpen(false)} title="নতুন কাস্টমার">
        <div className="space-y-3">
          <Field label="নাম"><input className={inputCls} value={form.name} onChange={(e) => set("name", e.target.value)} data-testid="cust-name" /></Field>
          <Field label="মোবাইল"><input className={inputCls} value={form.mobile} onChange={(e) => set("mobile", e.target.value)} data-testid="cust-mobile" /></Field>
          <Field label="ঠিকানা"><input className={inputCls} value={form.address} onChange={(e) => set("address", e.target.value)} /></Field>
          <Field label="ধরন"><select className={inputCls} value={form.type} onChange={(e) => set("type", e.target.value)} data-testid="cust-type"><option value="retail">খুচরা</option><option value="wholesale">পাইকারি</option></select></Field>
          <button onClick={save} className="w-full bg-[#1E3A2B] text-white h-11 rounded-xl font-medium" data-testid="save-customer-btn">সংরক্ষণ</button>
        </div>
      </Modal>
    </div>
  );
}
